/*
* @Author: LH
* @Date:   2018-08-05 23:22:32
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-14 14:47:48
*/
import { service } from '@/utils/request'

// const testUrl = 'http://192.168.1.203:8080'
  
export default {
	getType(data) {
	    return service({
	      	url: '/cms/catagory/GetContentTypeListByParentId',
	      	method: 'get',
	      	params: data
	    })
	},
  //获取列表
  getDataList: (data) => {
    return service({
      url: '/cms/content/getContentPageListByCascade',
      method: 'get',
      params: data
    })
  },
  /**
   * [getGestateTree 孕育树]
   * @param  {[obj]} params [id=knowledge]
   * @return {[obj]} 
   */
  getGestateTree(params) {
    return service({
      url: '/cms/catagory/getContentTypeTree',
      method: 'get',
      params: params
    })
  },
  /**
   * [getTypeInfo 获取分类]
   * @param  {[obj]} params [cId]
   * @return {[obj]}
   */
  getTypeInfo(params) {
    return service({
      url: '/cms/catagory/GetTypeInfo',
      method: 'get',
      params: params
    })    
  },
  /**
   * [addKnowledge 添加知识库]
   * @param {[obj]} data [表单数据]
   */
  addKnowledge(data) {
    return service({
      url: '/cms/content/Add',
      method: 'post',
      data: data
    })        
  },
  getKnowledge(params) {
    return service({
      url: '/cms/content/getContentById',
      method: 'get',
      params: params
    })   
  },
  updateKnowledge(data) {
    return service({
      url: '/cms/content/Update',
      method: 'post',
      data: data
    })
  },
  /**
   * [deleteKnowledge 删除知识库]
   * @param  {[obj]} data [id]
   * @return {[obj]} 
   */
  deleteKnowledge(data) {
    return service({
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest : [function (data) {
        let newData = ''
        for (let k in data) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
        }
        return newData
      }],
      url: '/cms/content/Delete',
      method: 'post',
      data: data
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/contentManage/gestateKnowledge.js